import { useEffect } from "react";
import styled from "styled-components";
import toast from "react-hot-toast";
import { getTranslation } from "./Utility.js";

const LabelInfo = styled.p`
  font-size: 18px;
  font-weight:500;
  margin:0;
  color:#c9ecee;
  letter-spacing:0.2em;
  strong {
  color: #f3efef;
  letter-spacing:normal;
  }
  a {
  cursor:pointer;
  }
  } 
`;
const Button = styled.button`
  /* Adapt the colors based on primary prop */
  background: #bf4f74;
  color: white;
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid #bf4f74;
  border-radius: 3px;
`;

const ButtonSvg = styled.button`
  /* Adapt the colors based on primary prop */
  background: transparent;
  border: none;
  cursor: pointer;
`;

const Link = styled.a`
  display: inline;
  align-items: center;
  color: #bf4f74;
  cursor: pointer;
  margin-left: 1vw;
`;

const UlBusinessHours = styled.ul`
  margin:0;
  text-align: left;
  color:rgb(0, 0, 0);
  letter-spacing:0.2em;
  strong {
  color:rgb(255, 246, 246);
  letter-spacing:normal;
  }
  a {
  cursor:pointer;
  }
  } 
`;
/**
 * A component that displays an story info box
 *
 * @param {string} props
 * @returns {JSX.Element}
 */
export function Info(options) {
  /**
   * A function that display business hours for a story
   * @param {string} key - A key for a business day
   *  @param {String[]} listOfHours - A list of available hours
   * @returns {JSX.Element} A single hour row
   */
  const showHourRow = (key, listOfHours) => {
    return (
      <li>
        {getTranslation(key)} :{" "}
        {getTranslation(listOfHours[key])
          ? getTranslation(listOfHours[key])
          : listOfHours[key]}
      </li>
    );
  };

  /**
   * A function that manages a business hour click event
   * @param {object} data - A list of hours
   * @returns {JSX.Element} A business hours UI
   */
  const handleClickBusinessHours = (data) => {
    if (!data) {
      return false;
    }
    const listOfHours = JSON.parse(data);
    toast(
      (t) => (
        <span>
          <UlBusinessHours>
            {Object.keys(listOfHours).map((key) =>
              showHourRow(key, listOfHours)
            )}
          </UlBusinessHours>
          <button onClick={() => toast.dismiss(t.id)}>
            {getTranslation("Dismiss")}
          </button>
        </span>
      ),
      {
        id: "bnHourId",
        duration: 10000,
      }
    );
    return false;
  };

  useEffect(() => {}, [options]);

  return (
    <div>
      <div className="info-wrapper">
        {options.data.name && <LabelInfo>{options.data.name}</LabelInfo>}
        <LabelInfo>
          {options.data.category && (
            <Button>{getTranslation(options.data.category)}</Button>
          )}
         {  options.data.website && (
            <Link href={options.data.website} target="_blank" rel="noreferrer">
              <img alt="" src="/link-square.svg" />
            </Link>
          ) }
          {options.data.businessHours && (
            <ButtonSvg
              onClick={() =>
                handleClickBusinessHours(options.data.businessHours)
              }
            >
              <img alt="" src="/24-hour-time-with-curve-arrow.svg" />
            </ButtonSvg>
          )}
         <Link
            href={`https://www.google.com/maps/dir/?api=1&destination=${options.data.position.lat},${options.data.position.lng}`}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src="/link-gmaps.svg" />
          </Link>
          <Link
            href={`https://maps.apple.com/?q=${options.data.position.lat},${options.data.position.lng}`}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src="/link-apple2.svg" />
          </Link>
          <Link
            href={`https://www.bing.com/maps/default.aspx?rtp=~pos.${options.data.position.lat}_${options.data.position.lng}`}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src="/link-bing.svg" />
          </Link>
          <Link
            href={`https://waze.com/ul?ll=${options.data.position.lat},${options.data.position.lng}&navigate=yes`}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src="/link-waze.svg" />
          </Link>
        </LabelInfo>
        <LabelInfo>
          {options.data.fullAddress && (
            <span>{`${options.data.fullAddress}`}</span>
          )}
          {options.data.city && <span>{` ${options.data.city}`}</span>}
          {options.data.country && <span>{` ${options.data.country}`}</span>}
        </LabelInfo>
        <p className="story-description">{options.data.description}</p>
      </div>
    </div>
  );
}

export default Info;
